import { isEmpty } from "lodash";

export function propsToInitialState(data, nhomChucNangList) {
  const dataInit = { ...data };
  dataInit.linhVuc = null;
  dataInit.app = null;
  dataInit.module = isEmpty(nhomChucNangList) ? null : nhomChucNangList?.find(x => x?.id === data?.moduleId);
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.appId = value?.appId || value?.app?.id || 0;
  dataSave.moduleId = value?.moduleId || value?.module?.id || 0;
  return dataSave;
}
